import { useState } from 'react';
import './load-card-detail.scss';
import { ClbIcon } from '@celebration/react';
import ILoadCardDetailProps from './interfaces/ILoadCardDetailProps';
import Details from './components/details';
import Rates from './components/rates';

function LoadCardDetail({
    initialVisibility,
    onClose,
    loadData,
    isPool,
}: Readonly<ILoadCardDetailProps>) {
    const [isVisible, setIsVisible] = useState(initialVisibility);

    const handleClose = () => {
        setIsVisible(false);
        onClose();
    };

    return (
        <div
            className="card-detail"
            style={{ visibility: isVisible ? 'visible' : 'hidden' }}
        >
            <div className="card-detail-header">
                <ClbIcon
                    icon="close"
                    size="md"
                    onClick={handleClose}
                    data-testid="close-button"
                />
            </div>
            <div className="card-detail-body">
                <Details loadData={loadData} />

                <div className="vertical-separator" />

                {isPool ? (
                    <Rates load={loadData} isPool />
                ) : (
                    <Rates load={loadData} />
                )}
            </div>
        </div>
    );
}

export default LoadCardDetail;
